"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
var _default = exports.default = {
  name: 'TableColumn',
  props: {
    column: {
      type: Object,
      default: () => ({
        showOverflowTooltip: true
      })
    }
  },
  computed: {
    _column() {
      return Object.assign({
        showOverflowTooltip: true
      }, this.column);
    },
    elAttrs() {
      const copy = {};
      for (const key in this._column) {
        if (_config.elTableColumnAttrs.includes(key)) {
          copy[key] = this._column[key];
        }
      }
      return copy;
    }
  }
};